export const environment = {
  ms_card_back: process.env.NG_APP_CARD_BACK_CERT,
  pci_proxy_url: process.env.NG_APP_PCI_PROXY_SDK_CERT,
  yuno_sdk: process.env.NG_APP_YUNO_SDK,
  production: true,
  experience: process.env.NG_APP_EXPERIENCE_CERT,
  wsUrl: process.env.NG_APP_WS_URL_CERT || 'wss://cert.payin.experience.monnet.io/api/v1/payin-checkout-experience/ws'
}
